export const FEATURE_GROUPS: Record<string, string[]> = {
  'Contracts (V1/V2)': ['contracts', 'price-amendments'],
  'Contracts V3': ['contracts-v3', 'contract-amendments', 'pricing-lines', 'pricing-histories'],
  Invoices: ['invoices', 'invoice-comments', 'invoice-line-items', 'invoice-payments'],
  Orders: ['orders', 'order-comments', 'order-line-items'],
  'Sales Contracts': [
    'sales-contracts',
    'sales-contract-comments',
    'sales-contract-hedge-items',
    'sales-contract-product-lines',
  ],
  'Delivery Tickets': ['delivery-tickets', 'delivery-ticket-products', 'delivery-ticket-splits'],
  'Work Orders': ['work-orders', 'work-order-applications', 'work-order-products'],
  Settlements: ['settlements', 'settlement-payment-adjustments', 'settlement-payouts'],
  Tickets: [
    'tickets',
    'splits',
    'ticket-splits',
    'ticket-applications',
    'ticket-ticket-applications',
  ],
}
